export { EventFAQs } from './EventFAQs';
export type { FAQ } from './types';
